// assets
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import CategoryOutlinedIcon from '@mui/icons-material/CategoryOutlined';
import CorporateFareIcon from '@mui/icons-material/CorporateFare';
import DomainIcon from '@mui/icons-material/Domain';
import FolderOutlinedIcon from '@mui/icons-material/FolderOutlined';
import GavelIcon from '@mui/icons-material/Gavel';
import GroupIcon from '@mui/icons-material/Group';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import LanguageIcon from '@mui/icons-material/Language';
import MapOutlinedIcon from '@mui/icons-material/MapOutlined';
import SavingsOutlinedIcon from '@mui/icons-material/SavingsOutlined';
import TranslateOutlinedIcon from '@mui/icons-material/TranslateOutlined';
import WatchLaterOutlinedIcon from '@mui/icons-material/WatchLaterOutlined';
import { ReactComponent as IconBranch } from 'assets/images/icons/branch-locator.svg';
import { ReactComponent as IconArea } from 'assets/images/icons/building.svg';
import { ReactComponent as IconOccupation } from 'assets/images/icons/businessman.svg';
import { ReactComponent as IconQualification } from 'assets/images/icons/certificate.svg';
import { ReactComponent as IconAffiliation } from 'assets/images/icons/degree.svg';
import { ReactComponent as IconDocument } from 'assets/images/icons/document.svg';
import { ReactComponent as IconEmployees } from 'assets/images/icons/employees.svg';
import { ReactComponent as IconResidence } from 'assets/images/icons/house.svg';
import { ReactComponent as IconSchool } from 'assets/images/icons/knowledge.svg';
import { ReactComponent as IconConsitution } from 'assets/images/icons/office-building.svg';
import { ReactComponent as IconCustomer } from 'assets/images/icons/people.svg';
import { ReactComponent as IconLocation } from 'assets/images/icons/placeholder.svg';
import { ReactComponent as IconPincode } from 'assets/images/icons/postcode.svg';
import { ReactComponent as IconReference } from 'assets/images/icons/reference.svg';
import { ReactComponent as IconRelationship } from 'assets/images/icons/relationships.svg';
import { ReactComponent as IconRole } from 'assets/images/icons/role.svg';
import { ReactComponent as IconClass } from 'assets/images/icons/school.svg';
import { ReactComponent as IconStage } from 'assets/images/icons/scientific.svg';
import { ReactComponent as IconLoan } from 'assets/images/icons/signing.svg';
import { ReactComponent as IconDesignation } from 'assets/images/icons/title.svg';
import { ReactComponent as IconCredit } from 'assets/images/icons/wallet.svg';

// constant
export const icons = {
	AccountBalanceOutlinedIcon,
	IconBranch,
	IconRole,
	MapOutlinedIcon,
	FolderOutlinedIcon,
	IconPincode,
	CategoryOutlinedIcon,
	IconQualification,
	TranslateOutlinedIcon,
	IconClass,
	IconDesignation,
	IconArea,
	IconConsitution,
	IconAffiliation,
	IconResidence,
	IconRelationship,
	IconOccupation,
	IconReference,
	SavingsOutlinedIcon,
	ArticleOutlinedIcon,
	IconSchool,
	IconLocation,
	IconCustomer,
	IconEmployees,
	Inventory2OutlinedIcon,
	WatchLaterOutlinedIcon,
	AccountTreeOutlinedIcon,
	IconLoan,
	IconStage,
	CorporateFareIcon,
	GroupIcon,
	LanguageIcon,
	IconCredit,
	IconDocument,
	GavelIcon,
	DomainIcon,
};
